import { Input, InputProps } from '@village/ui';
import { Path, useController } from 'react-hook-form';

type Props<FormSchema> = InputProps & {
    name: Path<FormSchema>;
};

const InputForm = <FormSchema,>({ name, ...inputProps }: Props<FormSchema>) => {
    const { field, fieldState } = useController({ name, disabled: inputProps.disabled });

    return <Input error={fieldState.error?.message} {...inputProps} {...field} value={field.value ?? ''} />;
};

export { InputForm };
